import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { Link, useParams, useHistory } from "react-router-dom";
import { api } from "../../Services/Axios";
import { track, setTrackedEmpreendimento } from "../../Services/Analytics";
import { getSlug } from "../../tenant";
import { QRCodeCanvas } from "qrcode.react";
import { config } from "react-spring";
import { useConfig } from "../../context/ConfigContext";
import LoadingScreen from "../LoadingScreen";
import ErrorScreen from "../ErrorScreen";
import {
  EmpreendimentoContainer,
  EmpreendimentoContainerBackground,
  LogoGafisa,
  HomeButton,
  EmpreendimentoTitle,
  EmpreendimentoQr,
  EmpreendimentoAddress,
  EmpreendimentoAddressDetails,
  EmpreendimentoDescription,
  EmpreendimentoImagem,
  EmpreendimentoPorcentagem,
  EmpreendimentoPorcentagemBarra,
  EmpreendimentoPorcentagemBarra2,
  EmpreendimentosPlantas,
  EmpreendimentosPlantasDegrade,
  EmpreendimentosPlantasThumb,
  EmpreendimentosThumbs,
  EmpreendimentoThumbTile,
  EmpreendimentosMap,
  EmpreendimentosMapEmbed,
  EmpreendimentosMapPath,
  EmpreendimentosMapInterests,
  EmpreendimentosMapInterestsItem,
  EmpreendimentosMapInterestsGradient,
  EmpreendimentosMapCloseBt,
  CarouselContainerFachada,
  CarouselContainerAreaComum,
  CarouselContainerPerspectivas,
  CarouselContainerGaleria,
  CarouselContainerPlantas,
  CarouselCloseButton,
  CarouselZoomButton,
  PlantaInferiorButton,
  PlantaSuperiorButton,
  ImageContainerFachada,
  ImageContainerAreaComum,
  ImageContainerPerspectivas,
  ImageContainerGaleria,
  ImageContainerPlantas,
  VideoThumbs,
  VideoThumb,
  VideoOverlay,
  VideoCloseButton,
  VideoGridOverlay,
  VideoGrid,
  VideoGridItem,
  VideoOverlayControls,
  VideoOverlayCloseButton,
  VideoViewToggle,
  VideoSplit,
  VideoSplitList,
  VideoSplitItem,
  VideoSplitPlayer,
  LinkOverlay,
} from "./styled";
import Maps from "./components/Maps";
import CarouselSliderFachada from "./components/CarouselSliderFachada";
import CarouselSliderAreaComum from "./components/CarouselSliderAreaComum";
import CarouselSliderPerspectivas from "./components/CarouselSliderPerspectivas";
import OpenedImageFachada from "./components/OpenedImageFachada";
import OpenedImageAreaComum from "./components/OpenedImageAreaComum";
import OpenedImagePerspectivas from "./components/OpenedImagePerspectivas";
import CarouselSliderGaleria from "./components/CarouselSliderGaleria";
import OpenedImageGaleria from "./components/OpenedImageGaleria";
import CarouselSliderPlantas from "./components/CarouselSliderPlantas";
import OpenedImagePlantas from "./components/OpenedImagePlantas";
import PipWindow from "./components/PipWindow";
import DragHint from "./components/DragHint";
import CarouselDots from "./components/CarouselDots";

// The gallery-video layout choice (thumbnail grid vs list + player) persists in
// localStorage, so the gallery reopens the way it was last left. Same key prefix
// / defensive read-write as the theme cache in ConfigContext.
const VIDEO_VIEW_KEY = "magicFolioVideoView";

function readVideoView() {
  try {
    const v = localStorage.getItem(VIDEO_VIEW_KEY);
    return v === "split" || v === "grid" ? v : "grid";
  } catch (e) {
    return "grid";
  }
}

function writeVideoView(view) {
  try {
    localStorage.setItem(VIDEO_VIEW_KEY, view);
  } catch (e) {
    /* ignore quota / disabled storage */
  }
}

const Empreendimento = () => {
  let { id } = useParams();
  const history = useHistory();
  const { configApp, appConfig, setConfigApp } = useConfig();

  // Kiosk idle timeout (admin global config, default 10 min): with no touch the
  // screen goes back to Start so the next visitor starts fresh. Any pointer/
  // touch/key, or a playing video, resets it. The reset closes the visit in
  // Granometrics (Services/Analytics: "Visita" ended by timeout).
  const IDLE_MS = (appConfig.idleTimeoutSeconds || 600) * 1000;
  const idleTimerRef = useRef(null);

  useEffect(() => {
    const goHome = () => {
      track.idle();
      history.push("/");
    };
    const resetIdle = () => {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(goHome, IDLE_MS);
    };
    const events = ["mousedown", "mousemove", "keydown", "wheel", "touchstart", "touchmove", "click"];
    events.forEach((e) => window.addEventListener(e, resetIdle, { passive: true }));
    // media events do not bubble; capture sees the gallery <video>
    document.addEventListener("timeupdate", resetIdle, true);
    resetIdle();
    return () => {
      clearTimeout(idleTimerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetIdle));
      document.removeEventListener("timeupdate", resetIdle, true);
    };
  }, [history, IDLE_MS]);

  const [imagesListFachada, setImagesListFachada] = useState([]);
  const [imagesListAreaComum, setImagesListAreaComum] = useState([]);
  const [imagesListPerspectivas, setImagesListPerspectivas] = useState([]);
  const [imagesListGaleria3, setImagesListGaleria3] = useState([]);
  const [imagesListGaleria4, setImagesListGaleria4] = useState([]);

  // Per-gallery video items (mp4). A gallery holding videos is shown as a
  // video-thumbnail grid (opened from its bottom-right tile) instead of the 3D
  // image carousel. Index-aligned with the galleries above (galeria-1..4).
  const [videosAreaComum, setVideosAreaComum] = useState([]);
  const [videosPerspectivas, setVideosPerspectivas] = useState([]);
  const [videosGaleria3, setVideosGaleria3] = useState([]);
  const [videosGaleria4, setVideosGaleria4] = useState([]);

  // Which gallery's videos are currently shown in the full-window grid overlay.
  // "" = hidden, "in" = visible (same show/hide pattern as the carousels).
  const [videoGridSetup, setVideoGridSetup] = useState({ class: "", videos: [] });
  // Video overlay layout: "grid" = thumbnail grid (tap plays fullscreen),
  // "split" = thumb list on the left + inline player on the right. Toggled by
  // the round button at the bottom of the overlay, and remembered in
  // localStorage so the gallery reopens in the layout last chosen.
  const [videoGridView, setVideoGridView] = useState(readVideoView);
  const [videoSplitIndex, setVideoSplitIndex] = useState(0);
  const splitVideoRef = useRef();

  // Gallery titles (client override or the default "Galeria N"), keyed by the
  // gallery slot — shown on each bottom-right gallery tile.
  const [galleryLabels, setGalleryLabels] = useState({});

  const [imagesListPlantas, setImagesListPlantas] = useState([]);

  // Picture in Picture: optional floating "map" image shown over the maximized
  // planta (admin uploads it as type = pip). null = no window.
  const [pipImage, setPipImage] = useState(null);

  const [videosList, setVideosList] = useState([]);
  // "" = hidden, "in" = overlay visible (same show/hide pattern as carousels).
  const [videoOverlayClass, setVideoOverlayClass] = useState("");
  const [videoSrc, setVideoSrc] = useState("");
  const videoRef = useRef();

  // Planta external link shown in an in-window iframe overlay.
  // "" = hidden, "in" = overlay visible (same show/hide pattern as the video).
  const [linkOverlayClass, setLinkOverlayClass] = useState("");
  const [linkSrc, setLinkSrc] = useState("");

  const [mapsInterestsList, setMapsInterestsList] = useState([
    {
      text: null,
      distance: null,
      atracao_id: null,
      empreendimento_id: null,
      location: null,
    },
  ]);

  const [isLoading, setIsLoading] = useState(true);

  const [errorScreen, setErrorScreen] = useState(false);

  const unidadesTotal = 150;

  const unidadesDisponiveis = 40;

  let porcentagemAtualTemp = 0;

  let porcentagemAtualTemp2 = 0;

  const porcentagemConcluida = Math.floor(Math.random() * 60) + 20;

  const porcentagemConcluida2 = Math.floor(Math.random() * 60) + 20;

  const [empreendimento, setEmpreendimento] = useState([]);

  const [unidadesAtuais, setUnidadesAtuais] = useState(unidadesTotal);

  let unidadesAtuaisTemp = unidadesTotal;

  const [porcentagemAtual, setPorcentagemAtual] = useState(0);

  const [porcentagemAtual2, setPorcentagemAtual2] = useState(0);

  const [empreendimentoClasses, setEmpreendimentoClasses] = useState({
    logoGafisa: "",
    empreendimentoTitle: "",
    empreendimentoAddress: "",
    empreendimentoAddressDetails: "",
    empreendimentoUnits: "",
    empreendimentoImagem: "",
    empreendimentoPorcentagem: "",
    empreendimentoDescription: "",
    empreendimentoPlantas: "",
    empreendimentoThumbs: "",
    empreendimentoMap: "",
    empreendimentoMapEmbed: "",
    empreendimentoMapList: "",
    empreendimentoMapPath: "",
    empreendimentoMapCloseBt: "",
  });

  const [classDuplexButtonInferior, setClassDuplexButtonInferior] =
    useState("active");
  const [classDuplexButtonSuperior, setClassDuplexButtonSuperior] =
    useState("");

  const [mapStyle, setMapStyle] = useState({
    width: "567.39px",
    height: "567.39px",
    borderRadius: "50%",
    transition: "all 1s ease-in-out 0s",
    pointerEvents: "none",
  });

  // The map needs no network: the empreendimento's coordinates and the
  // route to each atração come precomputed in the API payload (set at admin
  // time). mapCenter is null until the payload lands (or when the address
  // never geocoded); selectedRoute is the atração the visitor tapped.
  const [mapCenter, setMapCenter] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedAtracaoId, setSelectedAtracaoId] = useState(null);

  const [mapOpened, setMapOpened] = useState(false);

  const openedImageFachadaRef = useRef();
  const openedImageAreaComumRef = useRef();
  const openedImagePerspectivasRef = useRef();
  const openedImageGaleria3Ref = useRef();
  const openedImageGaleria4Ref = useRef();

  const openedImagePlantasRef = useRef();

  const [buildCarousel, setBuildCarousel] = useState(false);

  const [apiLoadedLength, setApiLoadedLength] = useState(0);
  const [slidersLoadedLength, setSlidersLoadedLength] = useState(0);
  // True once both gates below are satisfied — fills the loading bar while the
  // screen finishes its entrance timeout.
  const [loadGatesDone, setLoadGatesDone] = useState(false);

  const [setupCarouselFachada, setSetupCarouselFachada] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
  });

  const [setupCarouselAreaComum, setSetupCarouselAreaComum] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
  });

  const [setupCarouselPerspectivas, setSetupCarouselPerspectivas] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
  });

  const [setupCarouselGaleria3, setSetupCarouselGaleria3] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
  });

  const [setupCarouselGaleria4, setSetupCarouselGaleria4] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
  });

  const [setupCarouselPlantas, setSetupCarouselPlantas] = useState({
    class: "",
    slidesLength: 0,
    currentSlide: 0,
    goToSlide: 0,
    offsetRadius: 1,
    showNavigation: false,
    config: config.slow,
    imageOpened: "",
    isDuplex: false,
    floor: "inferior",
  });

  const [imageClosedFachada, _setImageClosedFachada] = useState(false);
  const imageClosedFachadaRef = useRef(imageClosedFachada);

  const setImageClosedFachada = (data) => {
    imageClosedFachadaRef.current = data;
    _setImageClosedFachada(data);
  };

  const [imageClosedAreaComum, _setImageClosedAreaComum] = useState(false);
  const imageClosedAreaComumRef = useRef(imageClosedAreaComum);

  const setImageClosedAreaComum = (data) => {
    imageClosedAreaComumRef.current = data;
    _setImageClosedAreaComum(data);
  };

  const [imageClosedPerspectivas, _setImageClosedPerspectivas] =
    useState(false);
  const imageClosedPerspectivasRef = useRef(imageClosedPerspectivas);

  const setImageClosedPerspectivas = (data) => {
    imageClosedPerspectivasRef.current = data;
    _setImageClosedPerspectivas(data);
  };

  const [imageClosedGaleria3, _setImageClosedGaleria3] = useState(false);
  const imageClosedGaleria3Ref = useRef(imageClosedGaleria3);

  const setImageClosedGaleria3 = (data) => {
    imageClosedGaleria3Ref.current = data;
    _setImageClosedGaleria3(data);
  };

  const [imageClosedGaleria4, _setImageClosedGaleria4] = useState(false);
  const imageClosedGaleria4Ref = useRef(imageClosedGaleria4);

  const setImageClosedGaleria4 = (data) => {
    imageClosedGaleria4Ref.current = data;
    _setImageClosedGaleria4(data);
  };

  const [imageClosedPlantas, _setImageClosedPlantas] = useState(false);

  const imageClosedPlantasRef = useRef(imageClosedPlantas);

  const setImageClosedPlantas = (data) => {
    imageClosedPlantasRef.current = data;
    _setImageClosedPlantas(data);
  };

  const listPlantasThumbs = imagesListPlantas.map((planta, index) => (
    <EmpreendimentosPlantasThumb
      key={index}
      className={appConfig.plantasMultiply ? "multiply" : ""}
      onClick={() => {
        openCarouselPlantas(index);
      }}
    >
      <div
        className="planta-bg"
        style={{ backgroundImage: `url(${planta.thumb})` }}
      />
      <div className="title">{planta.title}</div>
      <div className="text">{planta.text}</div>
    </EmpreendimentosPlantasThumb>
  ));

  const listMapsInterests = mapsInterestsList.map((mapItem, index) => (
    <EmpreendimentosMapInterestsItem
      key={index}
      className={`${empreendimentoClasses.empreendimentoMapList} ${
        selectedAtracaoId === mapItem.atracao_id ? "selected" : ""
      }`}
      onClick={() => {
        track.atracao(mapItem.text, mapItem.location);
        if (!mapOpened) {
          openMaps();
        }
        setSelectedRoute(mapItem.route);
        setSelectedAtracaoId(mapItem.atracao_id);
      }}
    >
      <div className={`meters ${empreendimentoClasses.empreendimentoMapList}`}>
        •
      </div>
      <div className={`text ${empreendimentoClasses.empreendimentoMapList}`}>
        {mapItem.text}
      </div>
    </EmpreendimentosMapInterestsItem>
  ));

  //**************** CAROUSEL Fachada  ***************/

  const openCarouselFachada = (index) => {
    // console.log(index);
    setSetupCarouselFachada((values) => ({
      ...values,
      class: "in",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
    }));
  };

  const closeCarouselFachada = () => {
    setSetupCarouselFachada((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImageFachada = () => {
    setSetupCarouselFachada((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImageFachada = () => {
    setSetupCarouselFachada((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedFachada(true);
    openedImageFachadaRef.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
  };

  //**************** CAROUSEL Área Comum  ***************/

  const openCarouselAreaComum = (index) => {
    // console.log(index);
    setSetupCarouselAreaComum((values) => ({
      ...values,
      class: "in",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
    }));
  };

  const closeCarouselAreaComum = () => {
    setSetupCarouselAreaComum((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImageAreaComum = () => {
    setSetupCarouselAreaComum((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImageAreaComum = () => {
    setSetupCarouselAreaComum((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedAreaComum(true);
    openedImageAreaComumRef.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
  };

  //**************** CAROUSEL PERSPECTIVAS  ***************/

  const openCarouselPerspectivas = (index) => {
    // console.log(index);
    setSetupCarouselPerspectivas((values) => ({
      ...values,
      class: "in",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
    }));
  };

  const closeCarouselPerspectivas = () => {
    setSetupCarouselPerspectivas((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImagePerspectivas = () => {
    setSetupCarouselPerspectivas((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImagePerspectivas = () => {
    setSetupCarouselPerspectivas((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedPerspectivas(true);
    openedImagePerspectivasRef.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
  };

  //**************** CAROUSEL GALERIA 3  ***************/

  const openCarouselGaleria3 = (index) => {
    setSetupCarouselGaleria3((values) => ({
      ...values,
      class: "in",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
    }));
  };

  const closeCarouselGaleria3 = () => {
    setSetupCarouselGaleria3((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImageGaleria3 = () => {
    setSetupCarouselGaleria3((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImageGaleria3 = () => {
    setSetupCarouselGaleria3((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedGaleria3(true);
    openedImageGaleria3Ref.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
  };

  //**************** CAROUSEL GALERIA 4  ***************/

  const openCarouselGaleria4 = (index) => {
    setSetupCarouselGaleria4((values) => ({
      ...values,
      class: "in",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
    }));
  };

  const closeCarouselGaleria4 = () => {
    setSetupCarouselGaleria4((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImageGaleria4 = () => {
    setSetupCarouselGaleria4((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImageGaleria4 = () => {
    setSetupCarouselGaleria4((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedGaleria4(true);
    openedImageGaleria4Ref.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
  };

  //**************** CAROUSEL Plantas  ***************/

  const openCarouselPlantas = (index) => {
    // console.log(index);
    setSetupCarouselPlantas((values) => ({
      ...values,
      class: "",
      currentSlide: index,
      goToSlide: index,
      imageOpened: "",
      isDuplex: imagesListPlantas[index].url2 !== "" ? true : false,
      floor: "inferior",
    }));
    openImagePlantas();
  };

  const closeCarouselPlantas = () => {
    setSetupCarouselPlantas((values) => ({
      ...values,
      class: "",
      imageOpened: "",
    }));
  };

  const openImagePlantas = () => {
    setSetupCarouselPlantas((values) => ({
      ...values,
      imageOpened: "in",
    }));
  };

  const closeImagePlantas = () => {
    setSetupCarouselPlantas((values) => ({
      ...values,
      class: "in",
      imageOpened: "",
    }));
    setImageClosedPlantas(true);
    openedImagePlantasRef.current.setFromOutside({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
    });
    closeCarouselPlantas();
    setClassDuplexButtonInferior("active");
    setClassDuplexButtonSuperior("");
  };

  const chooseDuplex = (value) => {
    setSetupCarouselPlantas((values) => ({
      ...values,
      floor: value,
    }));
    if (value === "inferior") {
      setClassDuplexButtonInferior("active");
      setClassDuplexButtonSuperior("");
    } else if (value === "superior") {
      setClassDuplexButtonInferior("");
      setClassDuplexButtonSuperior("active");
    }
  };

  //**************** VÍDEOS  ***************/

  // Open the full-window overlay and play the chosen video. The overlay already
  // covers the whole 1920×1080 stage, so it IS the fullscreen — we deliberately
  // do NOT call requestFullscreen(): native fullscreen would hide our own close
  // button (a sibling of the video) and leave a touch kiosk with no reliable way
  // to exit. Closing is always the on-overlay close button (below), plus onEnded.
  const openVideo = (url) => {
    setVideoSrc(url);
    setVideoOverlayClass("in");
    setTimeout(() => {
      const el = videoRef.current;
      if (!el) return;
      el.currentTime = 0;
      const p = el.play();
      if (p && p.catch) p.catch(() => {});
    }, 50);
  };

  const closeVideo = () => {
    const el = videoRef.current;
    if (el) {
      el.pause();
    }
    setVideoOverlayClass("");
    // Drop the source after the fade so the last frame doesn't flash on reopen.
    setTimeout(() => setVideoSrc(""), 300);
  };

  //**************** LINK DA PLANTA  ***************/

  // Planta links open in this overlay (an iframe over the stage), never in a new
  // tab/window: on a touch kiosk there is no way back from one. Closing is the
  // overlay's own close button.
  const openLink = (url) => {
    setLinkSrc(url);
    setLinkOverlayClass("in");
  };

  const closeLink = () => {
    setLinkOverlayClass("");
    // Drop the source after the fade so the page doesn't flash on reopen.
    setTimeout(() => setLinkSrc(""), 300);
  };

  // Open a gallery's videos (from its bottom-right tile) on the first video, in
  // whichever layout was last chosen (restored from localStorage).
  const openVideoGrid = (videos) => {
    setVideoGridSetup({ class: "in", videos });
    setVideoSplitIndex(0);
  };

  const closeVideoGrid = () => {
    // Stop the split player, otherwise its audio keeps running behind the
    // faded-out overlay.
    const el = splitVideoRef.current;
    if (el) el.pause();
    setVideoGridSetup((v) => ({ ...v, class: "" }));
  };

  // Bottom round button: grid <-> split (list + player).
  const toggleVideoGridView = () => {
    setVideoGridView((view) => {
      let next = "split";
      if (view === "split") {
        const el = splitVideoRef.current;
        if (el) el.pause();
        next = "grid";
      }
      writeVideoView(next);
      return next;
    });
    setVideoSplitIndex(0);
  };

  // Pick a video in the split view's left list and play it in the right player.
  const playSplitVideo = (index) => {
    setVideoSplitIndex(index);
    setTimeout(() => {
      const el = splitVideoRef.current;
      if (!el) return;
      el.currentTime = 0;
      const p = el.play();
      if (p && p.catch) p.catch(() => {});
    }, 50);
  };

  const openMaps = () => {
    if (!mapOpened) {
      setMapOpened(true);
      setEmpreendimentoClasses((classes) => ({
        ...classes,
        logoGafisa: "",
        empreendimentoTitle: "inMap",
        empreendimentoAddress: "inMap",
        empreendimentoAddressDetails: "",
        empreendimentoUnits: "",
        empreendimentoImagem: "",
        empreendimentoPorcentagem: "",
        empreendimentoDescription: "",
        empreendimentoPlantas: "",
        empreendimentoThumbs: "",
        empreendimentoMap: "in",
        empreendimentoMapEmbed: "in",
        empreendimentoMapList: "active",
        empreendimentoMapPath: "off",
        empreendimentoMapCloseBt: "in",
      }));
      setMapStyle((values) => ({
        ...values,
        width: "960px",
        height: "1080px",
        borderRadius: "0%",
        pointerEvents: "all",
      }));
    }
  };

  const closeMaps = () => {
    if (mapOpened) {
      setMapOpened(false);
      setEmpreendimentoClasses((classes) => ({
        ...classes,
        logoGafisa: "in",
        empreendimentoTitle: "in",
        empreendimentoAddress: "in",
        empreendimentoAddressDetails: "in",
        empreendimentoUnits: "in",
        empreendimentoImagem: "in",
        empreendimentoPorcentagem: "in",
        empreendimentoDescription: "in",
        empreendimentoPlantas: "in",
        empreendimentoThumbs: "in",
        empreendimentoMap: "in",
        empreendimentoMapEmbed: "",
        empreendimentoMapList: "",
        empreendimentoMapPath: "",
        empreendimentoMapCloseBt: "",
      }));
      setMapStyle((values) => ({
        ...values,
        width: "567.39px",
        height: "567.39px",
        borderRadius: "50%",
        pointerEvents: "none",
      }));
      setSelectedRoute(null);
      setSelectedAtracaoId(null);
    }
  };

  // Every navigation event on this screen carries the empreendimento, so
  // Granometrics can filter a gateway's metrics per empreendimento.
  useEffect(() => {
    setTrackedEmpreendimento(id);
    return () => setTrackedEmpreendimento(null);
  }, [id]);

  // Leaving the detail screen clears any background override so Home/Start
  // fall back to the configured gradient.
  useEffect(() => {
    return () => {
      setConfigApp((values) => ({ ...values, stageBg: null }));
    };
  }, []);

  useEffect(() => {
    api
      .get(`v1/empreendimentos/${id}`)
      .then(function (response) {
        if (response.data.success === true) {
          console.log("empreendimentos/id", response);
          let data = response.data.data;
          console.log(data);
          setEmpreendimento(data);

          // Per-empreendimento background: when the admin uploaded one, tell the
          // Stage to paint it in place of the gradient. No image -> gradient.
          if (data.background) {
            const stageBg = encodeURI(configApp.baseURLAssets + data.background)
              .replace(/\(/g, "%28")
              .replace(/\)/g, "%29");
            setConfigApp((values) => ({ ...values, stageBg }));
          }

          // Picture in Picture map: prefix + encode like the other asset URLs.
          if (data.pip) {
            setPipImage(
              encodeURI(configApp.baseURLAssets + data.pip)
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29")
            );
          }

          // Prefix a storage-relative path with the assets base and escape the
          // parens some filenames carry. Shared by the video + gallery builders.
          const enc = (s) =>
            encodeURI(configApp.baseURLAssets + s)
              .replace(/\(/g, "%28")
              .replace(/\)/g, "%29");

          // Split a gallery type into image items (fed to the 3D carousel) and
          // video items (mp4). Videos share the gallery with images; the backend
          // flags each one via files.kind[type]. Video items become thumbnail-
          // grid players (poster + legenda, tap to play fullscreen) below.
          const buildGallery = (type, defaultLabel) => {
            const f = response.data.data.files;
            const paths = f[type] || [];
            const kinds = f.kind?.[type] || [];
            const thumbs = f.thumb?.[type] || [];
            const legendas = f.legenda?.[type] || [];
            const label = f.labels?.[type] || defaultLabel;
            const images = [];
            const videos = [];
            paths.forEach((value, index) => {
              const text = legendas[index] || "";
              if (kinds[index] === "video") {
                // Caption: the legenda when set; otherwise the video's own file
                // name without the .mp4 extension (value is the raw storage path
                // + ?v=… cache-buster — take the basename, drop the query/ext).
                const fileName = (value.split("/").pop() || "")
                  .split("?")[0]
                  .replace(/\.mp4$/i, "");
                videos.push({
                  title: text || fileName,
                  url: enc(value),
                  thumb: thumbs[index] ? enc(thumbs[index]) : null,
                });
              } else {
                // thumb = the FULL image, not the 390px stored thumb: this only
                // feeds the bottom-right gallery tile, which paints at
                // background-size 160% (and doubles again on a 4K stage), so the
                // small thumb was being upscaled ~2.7x and looked pixelated.
                // The carousels read `url`, so nothing else is affected.
                images.push({
                  thumb: enc(value),
                  url: enc(value),
                  title: label,
                  text,
                });
              }
            });
            return { images, videos, label };
          };

          // Videos tab buttons: { title, url } — url is storage-relative, so
          // prefix it with the assets base (same as the image URLs above).
          const tabVideos = Array.isArray(data.videos)
            ? data.videos.map((v) => ({
                title: v.title,
                url: enc(v.url),
                thumb: v.thumb ? enc(v.thumb) : null,
              }))
            : [];

          let principalArr = response.data.data.files.principal.map(
            (value, index) => ({
              thumb: encodeURI(
                configApp.baseURLAssets +
                  response.data.data.files.thumb.principal[index]
              )
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              url: encodeURI(configApp.baseURLAssets + value)
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              title: response.data.data.files.labels?.principal || "Principal",
              text: response.data.data.files.legenda?.principal?.[index] || "",
            })
          );

          let fachadaArr = response.data.data.files.fachada.map(
            (value, index) => ({
              thumb: encodeURI(
                configApp.baseURLAssets +
                  response.data.data.files.thumb.fachada[index]
              )
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              url: encodeURI(configApp.baseURLAssets + value)
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              title: response.data.data.files.labels?.fachada || "Fachada",
              text: response.data.data.files.legenda?.fachada?.[index] || "",
            })
          );

          const g1 = buildGallery("galeria-1", "Galeria 1");
          const g2 = buildGallery("galeria-2", "Galeria 2");
          const g3 = buildGallery("galeria-3", "Galeria 3");
          const g4 = buildGallery("galeria-4", "Galeria 4");

          // Replace (not append) so a re-run of this fetch — React StrictMode's
          // double-invoke, or Fast Refresh preserving state across a hot reload
          // — doesn't stack duplicate copies into the lists (which showed up as
          // far too many carousel dots). Mirrors the plantas setter below.
          setImagesListFachada([...principalArr, ...fachadaArr]);

          setImagesListAreaComum(g1.images);

          setImagesListPerspectivas(g2.images);

          setImagesListGaleria3(g3.images);

          setImagesListGaleria4(g4.images);

          // Each gallery's videos stay with that gallery (shown as its own
          // video-thumbnail grid, opened from the gallery tile). They do NOT go
          // to the left-side videos-tab grid, which stays tab-only.
          setVideosAreaComum(g1.videos);
          setVideosPerspectivas(g2.videos);
          setVideosGaleria3(g3.videos);
          setVideosGaleria4(g4.videos);

          setGalleryLabels({
            areaComum: g1.label,
            perspectivas: g2.label,
            galeria3: g3.label,
            galeria4: g4.label,
          });

          setVideosList(tabVideos);
          setApiLoadedLength((value) => value + 1);
        } else {
          // console.log(response);
          setIsLoading(false);
          setErrorScreen(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
        setErrorScreen(true);
      });

    api
      .get(`v1/empreendimentos/${id}/plantas`)
      .then(function (response) {
        console.log("empreendimentos/id/plantas", response);
        if (response.data.success === true) {
          let plantasArr = response.data.data.map((value) => [
            {
              thumb: encodeURI(
                // configApp.baseURLAssets +
                value.image
              )
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              url: encodeURI(configApp.baseURLAssets + value.files[0])
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              url2: encodeURI(
                value.files[1] !== undefined
                  ? configApp.baseURLAssets + value.files[1]
                  : ""
              )
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29"),
              title: "Planta",
              text: value.name,
              link: value.link || "",
            },
          ]);
          // console.log("plantasArr", plantasArr);
          let tempArr = [];
          plantasArr.map((valor) => {
            tempArr = [...tempArr, ...valor];
          });
          setImagesListPlantas(tempArr);
          setApiLoadedLength((value) => value + 1);
        } else {
          // console.log(response);
          setIsLoading(false);
          setErrorScreen(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
        setErrorScreen(true);
      });
  }, []);

  useEffect(() => {
    if (empreendimento.attractions !== undefined) {
      setMapCenter(
        empreendimento.lat !== null && empreendimento.lng !== null
          ? { lat: Number(empreendimento.lat), lng: Number(empreendimento.lng) }
          : null
      );
      let arrayLocalidades = empreendimento.attractions;
      const tempMaps = arrayLocalidades.map((value) => {
        const pivot = value.pivot;
        const dest =
          value.lat !== null && value.lng !== null
            ? { lat: Number(value.lat), lng: Number(value.lng) }
            : null;
        return {
          text: value.name,
          distance: pivot.distance,
          order: pivot.order,
          atracao_id: pivot.atracao_id,
          empreendimento_id: pivot.empreendimento_id,
          location: value.address,
          // what the map draws for this atração (stored driving route, when
          // the admin side managed to compute one)
          route: {
            dest,
            polyline: pivot.route_polyline || null,
            distance_m: pivot.route_distance_m,
            duration_s: pivot.route_duration_s,
          },
        };
      });
      // Ordem manual definida no admin (coluna `order` do pivot). O backend já
      // devolve nessa ordem; reforçamos aqui para não depender da ordem do array.
      tempMaps.sort(function (a, b) {
        return (a.order ?? 0) - (b.order ?? 0);
      });
      // console.log(tempMaps);
      setMapsInterestsList([...tempMaps]);
      setApiLoadedLength((value) => value + 1);
    }
  }, [empreendimento]);

  const apiLoaded = () => {
    setIsLoading(false);
    setErrorScreen(false);
    setEmpreendimentoClasses((classes) => ({
      ...classes,
      logoGafisa: "in",
      empreendimentoTitle: "in",
      empreendimentoAddress: "in",
      empreendimentoAddressDetails: "in",
      empreendimentoUnits: "in",
      empreendimentoImagem: "in",
      empreendimentoPorcentagem: "in",
      empreendimentoDescription: "in",
      empreendimentoPlantas: "in",
      empreendimentoThumbs: "in",
      empreendimentoMap: "in",
      empreendimentoMapEmbed: "",
      empreendimentoMapList: "",
      empreendimentoMapPath: "",
      empreendimentoMapCloseBt: "",
    }));

    const barra = document.querySelector("#empreendimento-porcentagem");
    const barra2 = document.querySelector("#empreendimento-porcentagem2");

    setTimeout(() => {
      // The pink bars are hidden when units & available are both 0 (no elements).
      if (barra) barra.style.height = `${porcentagemConcluida}%`;
      if (barra2) barra2.style.height = `${porcentagemConcluida2}%`;
      let intervalUnidadesDisponiveis = setInterval(() => {
        if (unidadesAtuaisTemp >= unidadesDisponiveis) {
          let num = unidadesAtuaisTemp--;
          setUnidadesAtuais(num);
        } else {
          clearInterval(intervalUnidadesDisponiveis);
        }
      }, 10);

      let intervalPorcentagemAtual = setInterval(() => {
        if (porcentagemAtualTemp <= porcentagemConcluida) {
          let num2 = porcentagemAtualTemp++;
          setPorcentagemAtual(num2);
        } else {
          clearInterval(intervalPorcentagemAtual);
        }
      }, 20);

      let intervalPorcentagemAtual2 = setInterval(() => {
        if (porcentagemAtualTemp2 <= porcentagemConcluida2) {
          let num3 = porcentagemAtualTemp2++;
          setPorcentagemAtual2(num3);
        } else {
          clearInterval(intervalPorcentagemAtual2);
        }
      }, 20);
    }, 1500);
  };

  useEffect(() => {
    setSetupCarouselFachada((values) => ({
      ...values,
      slidesLength: imagesListFachada.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListFachada]);

  useEffect(() => {
    setSetupCarouselAreaComum((values) => ({
      ...values,
      slidesLength: imagesListAreaComum.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListAreaComum]);

  useEffect(() => {
    setSetupCarouselPerspectivas((values) => ({
      ...values,
      slidesLength: imagesListPerspectivas.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListPerspectivas]);

  useEffect(() => {
    setSetupCarouselGaleria3((values) => ({
      ...values,
      slidesLength: imagesListGaleria3.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListGaleria3]);

  useEffect(() => {
    setSetupCarouselGaleria4((values) => ({
      ...values,
      slidesLength: imagesListGaleria4.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListGaleria4]);

  useEffect(() => {
    setSetupCarouselPlantas((values) => ({
      ...values,
      slidesLength: imagesListPlantas.length,
    }));
    setSlidersLoadedLength((value) => value + 1);
  }, [imagesListPlantas]);

  // Granometrics "image seen": fire whenever a carousel is open (class "in") and
  // the current slide changes (incl. the opening slide). A tap into zoom is not
  // required — sliding to an image counts as seen. Same-second repeats are
  // de-duplicated server-side, so no client-side guard is needed.
  const granoFile = (u) => (u || "").split("/").pop().split("?")[0];

  useEffect(() => {
    if (setupCarouselFachada.class !== "in") return;
    const img = imagesListFachada[setupCarouselFachada.currentSlide];
    if (img) track.fachada(img.text || img.title, granoFile(img.url));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setupCarouselFachada.class, setupCarouselFachada.currentSlide]);

  useEffect(() => {
    // Plantas open straight into the zoomed image (imageOpened "in") rather than
    // the carousel "in" state the other galleries use, so gate on either.
    if (setupCarouselPlantas.class !== "in" && setupCarouselPlantas.imageOpened !== "in")
      return;
    const img = imagesListPlantas[setupCarouselPlantas.currentSlide];
    if (img) track.planta(img.text || img.title, granoFile(img.url));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setupCarouselPlantas.class,
    setupCarouselPlantas.imageOpened,
    setupCarouselPlantas.currentSlide,
  ]);

  useEffect(() => {
    if (setupCarouselAreaComum.class !== "in") return;
    const img = imagesListAreaComum[setupCarouselAreaComum.currentSlide];
    if (img) track.areasComuns(img.text || img.title, granoFile(img.url));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setupCarouselAreaComum.class, setupCarouselAreaComum.currentSlide]);

  useEffect(() => {
    if (setupCarouselPerspectivas.class !== "in") return;
    const img = imagesListPerspectivas[setupCarouselPerspectivas.currentSlide];
    if (img) track.living(img.text || img.title, granoFile(img.url));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setupCarouselPerspectivas.class, setupCarouselPerspectivas.currentSlide]);

  // `attractions` is optional: the effect above only counts it when the payload
  // carries it, so the empreendimento answers either 2 or 3 API responses.
  const apiCallsExpected = empreendimento.attractions !== undefined ? 3 : 2;

  // Single gate that dismisses the loading screen: all 12 slider setups plus
  // every API response this empreendimento actually has.
  //
  // This used to be two effects, one watching each counter, each testing an
  // exact pair (12 && 2 / 12 && 3). The counters land in separate, unbatched
  // renders (React 17 + promise callbacks + async passive-effect flush), so the
  // last increment often committed while the other counter was still stale in
  // the effect's closure — neither pair ever matched and the loader hung near
  // the end of the bar. Comparing with >= off both deps can't miss.
  useEffect(() => {
    // console.log("load gates", apiLoadedLength, slidersLoadedLength);
    if (loadGatesDone) return;
    if (slidersLoadedLength < 12 || apiLoadedLength < apiCallsExpected) return;

    setLoadGatesDone(true);
    setTimeout(() => {
      apiLoaded();
      setBuildCarousel(true);
      // console.log("api loaded");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slidersLoadedLength, apiLoadedLength, apiCallsExpected, loadGatesDone]);

  // Loading bar: the same gates that dismiss the loading screen — 12 slider
  // setups + the 2 required API responses (attractions is a 3rd, optional one,
  // so it's clamped out). Held just under 100% until both gates land.
  const loadingProgress = loadGatesDone
    ? 100
    : Math.min(
        95,
        Math.round(((slidersLoadedLength + Math.min(apiLoadedLength, 2)) / 14) * 100)
      );

  // Bottom-right galleries, in display order. Only populated ones are rendered;
  // the thumbs grid divides its space by how many survive the filter, so empty
  // galleries leave no gap (see EmpreendimentosThumbs $count).
  const bottomGalleries = [
    { images: imagesListAreaComum, videos: videosAreaComum, label: galleryLabels.areaComum, open: openCarouselAreaComum },
    { images: imagesListPerspectivas, videos: videosPerspectivas, label: galleryLabels.perspectivas, open: openCarouselPerspectivas },
    { images: imagesListGaleria3, videos: videosGaleria3, label: galleryLabels.galeria3, open: openCarouselGaleria3 },
    { images: imagesListGaleria4, videos: videosGaleria4, label: galleryLabels.galeria4, open: openCarouselGaleria4 },
  ].filter((g) => g.images[0] !== undefined || g.videos[0] !== undefined);

  return (
    <>
      {isLoading ? <LoadingScreen progress={loadingProgress} /> : null}
      {errorScreen ? <ErrorScreen /> : null}
      <EmpreendimentoContainer>
        <EmpreendimentoContainerBackground />
        <Link to="/">
          {/* Client logo (admin Config) when set; otherwise a HOME icon. */}
          {appConfig.logo ? (
            <LogoGafisa
              className={empreendimentoClasses.logoGafisa}
              style={{ backgroundImage: `url(${appConfig.logo.url})` }}
            />
          ) : (
            <HomeButton className={empreendimentoClasses.logoGafisa}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </HomeButton>
          )}
        </Link>
        <EmpreendimentoTitle
          className={empreendimentoClasses.empreendimentoTitle}
        >
          {/* Admin-uploaded per-empreendimento logo replaces the text title when
              present (same box/alignment); otherwise the name shows as text. */}
          {empreendimento.logo ? (
            <div
              className="logo"
              style={{
                backgroundImage: `url(${encodeURI(
                  configApp.baseURLAssets + empreendimento.logo
                )
                  .replace(/\(/g, "%28")
                  .replace(/\)/g, "%29")})`,
                // Admin-set logo width (px on the 1920×1080 stage); omit for default.
                ...(empreendimento.logo_width
                  ? { width: `${empreendimento.logo_width}px` }
                  : {}),
              }}
            />
          ) : (
            <div className="text">{empreendimento.name}</div>
          )}
          <div className="sub">{empreendimento.district}</div>
        </EmpreendimentoTitle>
        {empreendimento["qr-code"] ? (
          <EmpreendimentoQr
            className={empreendimentoClasses.empreendimentoAddress}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            {/* Encode a short tracking URL (/{slug}/qr?e=<id>) instead of the raw
                destination, so scanning records a slot-8 event and the target is
                resolved server-side before the phone is forwarded to the link. */}
            <QRCodeCanvas
              value={`${window.location.origin}/${getSlug()}/qr?e=${id}`}
              size={52}
              level="M"
            />
          </EmpreendimentoQr>
        ) : null}
        <EmpreendimentoAddress
          className={empreendimentoClasses.empreendimentoAddress}
        >
          {empreendimento.address}
          <br />
          <EmpreendimentoAddressDetails
            className={empreendimentoClasses.empreendimentoAddressDetails}
          >
            {empreendimento.high_description}
          </EmpreendimentoAddressDetails>
        </EmpreendimentoAddress>
        {imagesListFachada[0] !== undefined && (
          <EmpreendimentoImagem
            style={{
              backgroundImage: `url(${imagesListFachada[0].url})`,
            }}
            className={empreendimentoClasses.empreendimentoImagem}
            onClick={() => {
              openCarouselFachada(0);
            }}
          ></EmpreendimentoImagem>
        )}
        {(empreendimento.units > 0 || empreendimento.available > 0) && (
          <EmpreendimentoPorcentagem
            className={empreendimentoClasses.empreendimentoPorcentagem}
          >
            <EmpreendimentoPorcentagemBarra>
              <div id="empreendimento-porcentagem"></div>
            </EmpreendimentoPorcentagemBarra>
            <div className="number">{porcentagemAtual}</div>
            <EmpreendimentoPorcentagemBarra2>
              <div id="empreendimento-porcentagem2"></div>
            </EmpreendimentoPorcentagemBarra2>
            <div className="number2">{porcentagemAtual2}</div>
            {/* <div className="text">concluído</div> */}
          </EmpreendimentoPorcentagem>
        )}
        <EmpreendimentoDescription
          className={empreendimentoClasses.empreendimentoDescription}
          // Admin authors this with a rich-text editor (bold / italic / lists /
          // line breaks), so render it as HTML rather than plain text.
          dangerouslySetInnerHTML={{ __html: empreendimento.description || "" }}
        />
        <EmpreendimentosPlantasDegrade
          className={empreendimentoClasses.empreendimentoPlantas}
        />
        <EmpreendimentosPlantas
          className={empreendimentoClasses.empreendimentoPlantas}
        >
          {listPlantasThumbs}
        </EmpreendimentosPlantas>
        <EmpreendimentosThumbs
          className={empreendimentoClasses.empreendimentoThumbs}
        >
          {bottomGalleries.map((g, i) => {
            // Progressive scale-up: galeria 1 (far left) is the smallest, each
            // gallery to its right a bit bigger, all vertically centered on a
            // common midline. The bigger, right-most tiles sit in front (higher
            // z-index). Sizes/positions interpolate from index and are clamped
            // to stay inside the 1920 canvas (container is at left 1100 when
            // open; right edge ≤ ~1910).
            const n = bottomGalleries.length;
            // Count-based downscale: 1–2 galleries render full size, 3 and 4
            // shrink everything so the tiles spread wider and the per-tile
            // legends below don't overlap.
            const COUNT_SCALE = n <= 2 ? 1 : n === 3 ? 0.75 : 0.6;
            const BASE_W = Math.round(389 * COUNT_SCALE);
            const BASE_H = Math.round(272 * COUNT_SCALE);
            const CONTAINER_H = 272; // EmpreendimentosThumbs strip height
            const S_MIN = 0.85; // scale of the smallest (left-most) tile
            const t = n === 1 ? 1 : i / (n - 1);
            const scale = S_MIN + (1 - S_MIN) * t;
            const w = Math.round(BASE_W * scale);
            const h = Math.round(BASE_H * scale);
            const LEFT_START = 130; // left of galeria 1
            // Tight collage: each tile steps just over half a tile-width past
            // the previous one (legends stay clear via the width cap below).
            const STEP = Math.round(BASE_W * 0.55);
            const left = LEFT_START + STEP * i;
            // Cap each legend just short of the next tile's left edge so
            // adjacent legends can't collide.
            const legendW = i < n - 1 ? Math.min(w, STEP - 12) : w;
            const top = Math.round((CONTAINER_H - h) / 2); // center vertically
            // A gallery holding videos is a video gallery: its tile shows the
            // first video's poster and opens the video-thumbnail grid; otherwise
            // it shows the first image and opens the 3D carousel.
            const hasVideos = g.videos.length > 0;
            const cover = hasVideos ? g.videos[0] : g.images[0];
            return (
              <EmpreendimentoThumbTile
                key={i}
                style={{
                  width: `${w}px`,
                  height: `${h}px`,
                  left: `${left}px`,
                  top: `${top}px`,
                  zIndex: i + 1,
                  backgroundImage: `url(${cover.thumb})`,
                }}
                onClick={() => {
                  if (hasVideos) {
                    openVideoGrid(g.videos);
                  } else {
                    g.open(0);
                  }
                }}
              >
                <div className="text" style={{ width: `${legendW}px` }}>
                  {g.label || cover.title}
                </div>
              </EmpreendimentoThumbTile>
            );
          })}
        </EmpreendimentosThumbs>
        {videosList.length > 0 && (
          <VideoThumbs className={empreendimentoClasses.empreendimentoImagem}>
            {videosList.map((video, index) => (
              <VideoThumb
                key={index}
                onClick={() => {
                  track.video(video.title, (video.url || "").split("/").pop().split("?")[0]);
                  openVideo(video.url);
                }}
                style={
                  video.thumb
                    ? { backgroundImage: `url(${video.thumb})` }
                    : undefined
                }
              >
                <span className="label">{video.title}</span>
              </VideoThumb>
            ))}
          </VideoThumbs>
        )}
        <EmpreendimentosMap className={empreendimentoClasses.empreendimentoMap}>
          <EmpreendimentosMapEmbed
            className={empreendimentoClasses.empreendimentoMapEmbed}
            onClick={() => {
              openMaps();
            }}
          >
            <Maps mapStyle={mapStyle} center={mapCenter} route={selectedRoute} />
          </EmpreendimentosMapEmbed>
          <EmpreendimentosMapPath
            className={empreendimentoClasses.empreendimentoMapPath}
          />
          <EmpreendimentosMapInterests
            className={empreendimentoClasses.empreendimentoMapList}
          >
            {listMapsInterests}
          </EmpreendimentosMapInterests>
        </EmpreendimentosMap>
        <EmpreendimentosMapInterestsGradient
          className={empreendimentoClasses.empreendimentoMapList}
        />
        <EmpreendimentosMapCloseBt
          onClick={closeMaps}
          className={empreendimentoClasses.empreendimentoMapCloseBt}
        />

        {buildCarousel && (
          <>
            <CarouselContainerFachada className={setupCarouselFachada.class}>
              <CarouselSliderFachada
                setupCarouselFachada={setupCarouselFachada}
                setSetupCarouselFachada={setSetupCarouselFachada}
                imagesListFachada={imagesListFachada}
              />
              <CarouselDots
                count={imagesListFachada.length}
                current={setupCarouselFachada.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselFachada} />
              <CarouselZoomButton onClick={openImageFachada} />
              <DragHint
                active={setupCarouselFachada.class === "in"}
                imageCount={imagesListFachada.length}
              />
            </CarouselContainerFachada>
            <CarouselContainerAreaComum
              className={setupCarouselAreaComum.class}
            >
              <CarouselSliderAreaComum
                setupCarouselAreaComum={setupCarouselAreaComum}
                setSetupCarouselAreaComum={setSetupCarouselAreaComum}
                imagesListAreaComum={imagesListAreaComum}
              />
              <CarouselDots
                count={imagesListAreaComum.length}
                current={setupCarouselAreaComum.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselAreaComum} />
              <CarouselZoomButton onClick={openImageAreaComum} />
              <DragHint
                active={setupCarouselAreaComum.class === "in"}
                imageCount={imagesListAreaComum.length}
              />
            </CarouselContainerAreaComum>
            <CarouselContainerPerspectivas
              className={setupCarouselPerspectivas.class}
            >
              <CarouselSliderPerspectivas
                setupCarouselPerspectivas={setupCarouselPerspectivas}
                setSetupCarouselPerspectivas={setSetupCarouselPerspectivas}
                imagesListPerspectivas={imagesListPerspectivas}
              />
              <CarouselDots
                count={imagesListPerspectivas.length}
                current={setupCarouselPerspectivas.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselPerspectivas} />
              <CarouselZoomButton onClick={openImagePerspectivas} />
              <DragHint
                active={setupCarouselPerspectivas.class === "in"}
                imageCount={imagesListPerspectivas.length}
              />
            </CarouselContainerPerspectivas>
            <CarouselContainerGaleria className={setupCarouselGaleria3.class}>
              <CarouselSliderGaleria
                setup={setupCarouselGaleria3}
                setSetup={setSetupCarouselGaleria3}
                imagesList={imagesListGaleria3}
              />
              <CarouselDots
                count={imagesListGaleria3.length}
                current={setupCarouselGaleria3.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselGaleria3} />
              <CarouselZoomButton onClick={openImageGaleria3} />
              <DragHint
                active={setupCarouselGaleria3.class === "in"}
                imageCount={imagesListGaleria3.length}
              />
            </CarouselContainerGaleria>
            <CarouselContainerGaleria className={setupCarouselGaleria4.class}>
              <CarouselSliderGaleria
                setup={setupCarouselGaleria4}
                setSetup={setSetupCarouselGaleria4}
                imagesList={imagesListGaleria4}
              />
              <CarouselDots
                count={imagesListGaleria4.length}
                current={setupCarouselGaleria4.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselGaleria4} />
              <CarouselZoomButton onClick={openImageGaleria4} />
              <DragHint
                active={setupCarouselGaleria4.class === "in"}
                imageCount={imagesListGaleria4.length}
              />
            </CarouselContainerGaleria>
            <CarouselContainerPlantas className={setupCarouselPlantas.class}>
              <CarouselSliderPlantas
                setupCarouselPlantas={setupCarouselPlantas}
                setSetupCarouselPlantas={setSetupCarouselPlantas}
                imagesListPlantas={imagesListPlantas}
              />
              <CarouselDots
                count={imagesListPlantas.length}
                current={setupCarouselPlantas.currentSlide}
              />
              <CarouselCloseButton onClick={closeCarouselPlantas} />
              <CarouselZoomButton onClick={openImagePlantas} />
            </CarouselContainerPlantas>
          </>
        )}
        <ImageContainerFachada className={setupCarouselFachada.imageOpened}>
          <OpenedImageFachada
            ref={openedImageFachadaRef}
            setupCarouselFachada={setupCarouselFachada}
            imagesListFachada={imagesListFachada}
            imageClosedFachada={imageClosedFachada}
            setImageClosedFachada={setImageClosedFachada}
          />
          <CarouselCloseButton onClick={closeImageFachada} />
        </ImageContainerFachada>
        <ImageContainerAreaComum className={setupCarouselAreaComum.imageOpened}>
          <OpenedImageAreaComum
            ref={openedImageAreaComumRef}
            setupCarouselAreaComum={setupCarouselAreaComum}
            imagesListAreaComum={imagesListAreaComum}
            imageClosedAreaComum={imageClosedAreaComum}
            setImageClosedAreaComum={setImageClosedAreaComum}
          />
          <CarouselCloseButton onClick={closeImageAreaComum} />
        </ImageContainerAreaComum>
        <ImageContainerPerspectivas
          className={setupCarouselPerspectivas.imageOpened}
        >
          <OpenedImagePerspectivas
            ref={openedImagePerspectivasRef}
            setupCarouselPerspectivas={setupCarouselPerspectivas}
            imagesListPerspectivas={imagesListPerspectivas}
            imageClosedPerspectivas={imageClosedPerspectivas}
            setImageClosedPerspectivas={setImageClosedPerspectivas}
          />
          <CarouselCloseButton onClick={closeImagePerspectivas} />
        </ImageContainerPerspectivas>
        <ImageContainerGaleria className={setupCarouselGaleria3.imageOpened}>
          <OpenedImageGaleria
            ref={openedImageGaleria3Ref}
            setup={setupCarouselGaleria3}
            imagesList={imagesListGaleria3}
            imageClosed={imageClosedGaleria3}
            setImageClosed={setImageClosedGaleria3}
          />
          <CarouselCloseButton onClick={closeImageGaleria3} />
        </ImageContainerGaleria>
        <ImageContainerGaleria className={setupCarouselGaleria4.imageOpened}>
          <OpenedImageGaleria
            ref={openedImageGaleria4Ref}
            setup={setupCarouselGaleria4}
            imagesList={imagesListGaleria4}
            imageClosed={imageClosedGaleria4}
            setImageClosed={setImageClosedGaleria4}
          />
          <CarouselCloseButton onClick={closeImageGaleria4} />
        </ImageContainerGaleria>
        <ImageContainerPlantas className={setupCarouselPlantas.imageOpened}>
          <OpenedImagePlantas
            ref={openedImagePlantasRef}
            setupCarouselPlantas={setupCarouselPlantas}
            imagesListPlantas={imagesListPlantas}
            imageClosedPlantas={imageClosedPlantas}
            setImageClosedPlantas={setImageClosedPlantas}
            openLink={openLink}
          />
          <CarouselCloseButton onClick={closeImagePlantas} />
          {pipImage && <PipWindow pipImage={pipImage} />}
          {setupCarouselPlantas.isDuplex && (
            <>
              <PlantaInferiorButton
                className={classDuplexButtonInferior}
                onClick={() => chooseDuplex("inferior")}
              >
                Inferior
              </PlantaInferiorButton>
              <PlantaSuperiorButton
                className={classDuplexButtonSuperior}
                onClick={() => chooseDuplex("superior")}
              >
                Superior
              </PlantaSuperiorButton>
            </>
          )}
        </ImageContainerPlantas>
        {ReactDOM.createPortal(
          <VideoGridOverlay className={videoGridSetup.class}>
            {videoGridView === "split" ? (
              <VideoSplit>
                <VideoSplitList>
                  {videoGridSetup.videos.map((video, index) => (
                    <VideoSplitItem
                      key={index}
                      className={index === videoSplitIndex ? "active" : ""}
                      onClick={() => {
                        track.video(
                          video.title,
                          (video.url || "").split("/").pop().split("?")[0]
                        );
                        playSplitVideo(index);
                      }}
                    >
                      <div
                        className="thumb"
                        style={
                          video.thumb
                            ? { backgroundImage: `url(${video.thumb})` }
                            : undefined
                        }
                      />
                      {video.title ? (
                        <div className="caption">{video.title}</div>
                      ) : null}
                    </VideoSplitItem>
                  ))}
                </VideoSplitList>
                <VideoSplitPlayer>
                  {videoGridSetup.videos[videoSplitIndex] && (
                    <video
                      ref={splitVideoRef}
                      src={videoGridSetup.videos[videoSplitIndex].url}
                      poster={
                        videoGridSetup.videos[videoSplitIndex].thumb || undefined
                      }
                      controls
                      playsInline
                    />
                  )}
                </VideoSplitPlayer>
              </VideoSplit>
            ) : (
              <VideoGrid>
                {videoGridSetup.videos.map((video, index) => (
                  <VideoGridItem
                    key={index}
                    onClick={() => {
                      track.video(
                        video.title,
                        (video.url || "").split("/").pop().split("?")[0]
                      );
                      openVideo(video.url);
                    }}
                  >
                    <div
                      className="thumb"
                      style={
                        video.thumb
                          ? { backgroundImage: `url(${video.thumb})` }
                          : undefined
                      }
                    />
                    {video.title ? (
                      <div className="caption">{video.title}</div>
                    ) : null}
                  </VideoGridItem>
                ))}
              </VideoGrid>
            )}
            {/* Bottom control row — close + view toggle side by side, same as
                the carousels. The toggle shows the layout it switches TO: a
                list glyph while in grid view, a grid glyph while in split. */}
            <VideoOverlayControls>
              <VideoOverlayCloseButton onClick={closeVideoGrid} />
              <VideoViewToggle
                onClick={toggleVideoGridView}
                title={
                  videoGridView === "split"
                    ? "Ver em grade"
                    : "Ver em lista com player"
                }
              >
                {videoGridView === "split" ? (
                  <svg viewBox="0 0 24 24">
                    <rect x="2" y="2" width="9" height="9" rx="1.5" />
                    <rect x="13" y="2" width="9" height="9" rx="1.5" />
                    <rect x="2" y="13" width="9" height="9" rx="1.5" />
                    <rect x="13" y="13" width="9" height="9" rx="1.5" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24">
                    <rect x="2" y="3" width="7" height="5" rx="1" />
                    <rect x="2" y="10" width="7" height="5" rx="1" />
                    <rect x="2" y="17" width="7" height="5" rx="1" />
                    <rect x="11" y="3" width="11" height="19" rx="1.5" />
                  </svg>
                )}
              </VideoViewToggle>
            </VideoOverlayControls>
          </VideoGridOverlay>,
          document.body
        )}
        {ReactDOM.createPortal(
          <VideoOverlay className={videoOverlayClass}>
            {videoSrc && (
              <video
                ref={videoRef}
                src={videoSrc}
                controls
                playsInline
                onEnded={closeVideo}
              />
            )}
            <VideoCloseButton onClick={closeVideo} />
          </VideoOverlay>,
          document.body
        )}
        {ReactDOM.createPortal(
          <LinkOverlay className={linkOverlayClass}>
            {linkSrc &&
              (navigator.onLine ? (
                <iframe src={linkSrc} title="Link da planta" />
              ) : (
                <div
                  style={{
                    color: "#fff",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "2em",
                  }}
                >
                  Conteúdo externo indisponível sem conexão
                </div>
              ))}
            <VideoCloseButton onClick={closeLink} />
          </LinkOverlay>,
          document.body
        )}
      </EmpreendimentoContainer>
    </>
  );
};

export default Empreendimento;
